package one.devsbox.www.ui.widgets

import androidx.compose.runtime.Composable
import tk.mallumo.compose.navigation.ComposableNavNode


@Composable
@ComposableNavNode
fun EmptyUI() {

}